import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticationApiService } from '@warema/shared/authentication/api';
import { SpinnerComponent } from '@warema/shared/components';
import { IceService } from '@warema/shared/services';
import { AppStateService } from '@warema/warema-plus/scaffold';
import { DashboardPrivateComponent, DashboardPublicComponent } from '@warema/warema-plus/shared/components';

@Component({
    selector: 'warema-plus-root',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, DashboardPrivateComponent, DashboardPublicComponent, SpinnerComponent],
})
export class RootComponent {
    public readonly authenticationApiService = inject(AuthenticationApiService);
    private readonly _appStateService = inject(AppStateService);
    private readonly _iceService = inject(IceService);

    constructor() {
        this._appStateService.translateService.onLangChange
            .pipe(takeUntilDestroyed())
            .subscribe(langChangeEvent => this._iceService.setLanguage(langChangeEvent.lang));
    }
}
